import React from 'react'
import Buscador from '../../Home/SeccionBuscador/Buscador'
//import Filtros from './Filtros'

class SeccionIzquierda extends React.Component {
  constructor(props) {
      super(props)
      //FC: del Buscador
      this.handleCombosBusquedaChange = this.handleCombosBusquedaChange.bind(this);
      this.handleCombosOrigenBusquedaChange = this.handleCombosOrigenBusquedaChange.bind(this);
      this.handleCombosDestinoBusquedaChange = this.handleCombosDestinoBusquedaChange.bind(this);
      this.handleAdultosChange = this.handleAdultosChange.bind(this);
      this.handleMenoresChange = this.handleMenoresChange.bind(this);
      this.handleEdadChange = this.handleEdadChange.bind(this);
  }



  handleCombosBusquedaChange(propiedad, valor) {
      this.props.onSelectChange(propiedad, valor);
  }

  handleCombosOrigenBusquedaChange(valor) {
      this.props.onSelectOrigenChange(valor);
  }

  handleCombosDestinoBusquedaChange(valor) {
      this.props.onSelectDestinoChange(valor);
  }

  handleAdultosChange(fecha) {
      this.props.onAdultosChange(fecha);
  }

  handleMenoresChange(fecha) {
      this.props.onMenoresChange(fecha);
  }

  handleEdadChange(clave, valor) {
      this.props.onEdadChange(clave, valor);
  }

  render() {
    const estilos = {estilo1: '', estilosInputs: '', estilosInputFecha: '', estiloBoton: '', estilosHabitaciones: '',
                     estiloEdadMenor: 'col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12'};

      return (
              <aside className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                <div className="filtros">
                  <Buscador busqueda={this.props.busqueda}
                            estilos={estilos}
                            onSelectChange={this.handleCombosBusquedaChange}
                            onSelectOrigenChange={this.handleCombosOrigenBusquedaChange}
                            onSelectDestinoChange={this.handleCombosDestinoBusquedaChange}
                            onAdultosChange={this.handleAdultosChange}
                            onMenoresChange={this.handleMenoresChange}
                            onEdadChange={this.handleEdadChange}
                            solosYsolas={this.props.solosYsolas}
                            />
                  </div>
                  {/*<Filtros />*/}
            </aside>
            )
          }
}

export default SeccionIzquierda



// WEBPACK FOOTER //
// ./src/components/Resultados/SeccionIzquierda/index.js